import { render } from "./leader.vue?vue&type=template&id=02a1d369&scoped=true"
import script from "./leader.vue?vue&type=script&lang=js"
export * from "./leader.vue?vue&type=script&lang=js"

import "./leader.vue?vue&type=style&index=0&id=02a1d369&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-02a1d369"

export default script